<div class="container-fluid">
  <app-header titleText="JOBS" i18n-titleText progressBarState="job"></app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/project_management_circle.png" alt="Job Icon" class="card-icon" />

      <div *ngIf="job && job.customer">
        <h5>
          <a *ngIf="!isFieldTech" [routerLink]="['/customer', job.customer.customer_ID]">
            {{job.customer.customer_BusinessName}}
          </a>
          <span *ngIf="isFieldTech">
            {{job.customer.customer_BusinessName}}
          </span>
        </h5>
        <div class="row header-text">

          <div class="col-md-2">
            <ng-template [ngIf]="job.customer.customer_Address1">{{job.customer.customer_Address1}}<br /></ng-template>
            <ng-template [ngIf]="job.customer.customer_Address2">{{job.customer.customer_Address2}}<br /></ng-template>
            <ng-template [ngIf]="job.customer.customer_City || job.customer.customer_State || job.customer.customer_Portal">
              {{job.customer.customer_City}}, {{job.customer.customer_State}} {{job.customer.customer_Postal}}<br>
            </ng-template>
            <span i18n>Contact:</span> {{job.customer.contact_LastName}}, {{job.customer.contact_FirstName}}<br />
            <span *ngIf=job.customer.contact_Phone><span i18n>Phone:</span> {{job.customer.contact_Phone}}<br /></span>
            <span *ngIf=job.customer.contact_Mobile><span i18n>Cell:</span> {{job.customer.contact_Mobile}}<br /></span>
            <span *ngIf=job.customer.contact_Email>{{job.customer.contact_Email}}<br /></span>
            <ng-template [ngIf]="job.customer.customer_Email">{{job.customer.customer_Email}}<br /></ng-template>
            <ng-template [ngIf]="job.customer.customerType">{{job.customer.customerType.customerType_Desc}}<br /></ng-template>
            <ng-template [ngIf]="job.customer.office">Office: {{job.customer.office.office_Desc}}<br /></ng-template>
          </div>

          <div class="col-md-2">
            <span *ngIf="job.jobType">{{job.jobType.jobType_Desc}}<br /></span>
            <span i18n>Office:</span> <span *ngIf="job.office">{{job.office.office_Name}}</span><br />
            <span i18n>Salesperson:</span> <span *ngFor="let assignment of job.quoteAssignments">{{assignment.assignedTo.lastName}}, {{assignment.assignedTo.firstName}}</span><br />
            <span i18n>Plan Date:</span> {{job.quote_PlanDate | date: 'MM/dd/yyyy'}}<br />
            <span i18n>Ready Date:</span> {{job.quote_ReadyDate | date: 'MM/dd/yyyy'}}
          </div>

          <div class="col-md-2">
            <span i18n>Project:</span> {{job.quote_Name}} #{{job.quote_ProjectNumber}}
            <button *ngIf="canEdit" type="button" class="btn btn-bidit-edit" (click)="editAddress()"></button>
            <br />
            <span i18n>Job Address</span><br />
            <ng-template [ngIf]="job.quote_Address1">{{job.quote_Address1}}<br /></ng-template>
            <ng-template [ngIf]="job.quote_Address2">{{job.quote_Address2}}<br /></ng-template>
            <ng-template [ngIf]="job.quote_City || job.quote_State || job.quote_Portal">
              {{job.quote_City}}, {{job.quote_State}} {{job.quote_Portal}}<br />
            </ng-template>
            <div class="form-inline">
              <span class="bold mr-1" i18n>Job Status:</span><br />
              <span *ngIf="job.quote_IsLost" style="color:red;">{{getJobStatusName(job)}}</span>
              <span *ngIf="!job.quote_IsLost" class="text-success">{{getJobStatusName(job)}}</span>
            </div><br />
          </div>

          <div class="col-md-6" align="right">
            <h7 *ngIf="!isFieldTech"><span i18n>Contract Amount:</span> ${{job.contractAmount | number: '1.0'}}</h7><br />
            <h7><span i18n>Created By:</span> <ng-template [ngIf]="job.createdBy">{{job.createdBy.firstName}} {{job.createdBy.lastName}}</ng-template></h7><br />
            <h7><span i18n>Date:</span> {{job.quote_Created | date: 'M/d/yyyy'}}</h7><br />

            <div class="float-right form-inline">

              <div>
                <label for="lostStatus" class="col-form-label" i18n>Job Status</label>
                <select class="form-control select-bidit" name="lostStatus" id="lostStatus"
                        [disabled]="!canEdit"
                        [(ngModel)]="lostStatus"
                        (change)="jobStatusChanged()">
                  <option value="" i18n>Active</option>
                  <option value="C" i18n>Canceled</option>
                  <option value="CP" i18n>Completed</option>
                </select>
              </div>
              <button *ngIf="!isRequesting && !isFieldTech  &&  allowPrint" type="button" (click)="openPrintOptionsDialog()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Print</button>
              <button *ngIf="!isRequesting && !isFieldTech && showQuoteAnalysis" type="button" (click)="quoteAnalysis()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Quote Analysis</button>
              <button *ngIf="!isRequesting && !isFieldTech" type="button" (click)="materialList()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Material List</button>
            </div>
            <app-spinner [isRunning]="isRequesting"></app-spinner>
          </div>
        </div>

        <mat-tab-group>
          <mat-tab label="Work Orders" i18n-label>
            <div class="content">
              <div class="">
                <div class="p-2">
                  <span i18n>The following work orders have been created for the selected job</span>
                  <button *ngIf="canAddWorkOrder" class="ml-2 btn btn-bidit-navigate" (click)="addWorkOrder()" i18n>Add Work Order</button>
                  <button *ngIf="canAddWorkOrder" class="ml-2 btn btn-bidit-navigate" (click)="addCustomWorkOrderItem()" i18n>Add Custom Work Area</button>
                  <button *ngIf="canEditWorkOrder && checkSendAllowSendNotifications()" class="ml-2 btn btn-bidit-navigate" (click)="sendNotification()" i18n>Send Notification</button>

                </div>
                <table class="table table-bidit table-striped">
                  <thead>
                    <tr>
                      <th i18n>Area</th>
                      <th i18n>Item</th>
                      <th i18n>WO #</th>
                      <th i18n>Type</th>
                      <th i18n>Start Date</th>
                      <th i18n>End Date</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    <ng-template ngFor let-area [ngForOf]="areaSummaries">
                      <tr>
                        <td colspan="8">
                          <b>{{area.area_Name}}</b>
                        </td>
                      </tr>
                      <ng-template ngFor let-quoteArea [ngForOf]="area.quoteAreas">
                        <tr>
                          <td>
                          </td>
                          <td colspan="7">
                            <b>
                              <span *ngIf="quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.area_Name}}</span>
                              <span *ngIf="!quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.subArea.subArea_Name}}</span>
                            </b> - {{quoteArea.acceptedItem.area_SqrFtg}} <span i18n>SqrFtg</span><br />
                            <span *ngIf="quoteArea.acceptedItem.item">
                              {{quoteArea.acceptedItem.item.item_Name}}
                            </span>
                          </td>
                        </tr>
                        <tr *ngFor="let workOrder of quoteArea.workOrders">
                          <td></td>
                          <td></td>
                          <td>{{workOrder.workOrder_Seq}}</td>
                          <td><span *ngIf="workOrder.workOrderType">{{workOrder.workOrderType.workOrderType_Desc}}</span></td>
                          <td>{{workOrder.workOrder_Start | date: 'MM/dd/yyyy h:mm a'}}</td>
                          <td>{{workOrder.workOrder_Stop | date: 'MM/dd/yyyy h:mm a'}}</td>
                          <td>
                            <button *ngIf="canEditWorkOrder" type="button" class="btn btn-bidit-edit" (click)="editWorkOrder(workOrder)"></button>

                          </td>
                        </tr>
                      </ng-template>
                    </ng-template>
                    <tr>
                      <td colspan="7">
                        <b i18n>Custom Areas</b>
                      </td>
                    </tr>
                    <ng-template ngFor let-customItem [ngForOf]="jobCustomItems">
                      <tr>
                        <td colspan="1">
                        </td>
                        <td colspan="7">
                          {{customItem.customItemDescription}} - {{customItem.customItemProduct}}
                          <button *ngIf="canEditWorkOrder && customItem.jobCustomItem_ID !== null " type="button" class="btn btn-bidit-edit" (click)="editCustomItem(customItem.jobCustomItem_ID)"></button>
                        </td>
                      </tr>
                      <ng-template ngFor let-workOrder [ngForOf]="customItem.workOrders">
                        <tr>
                          <td colspan="2">
                          </td>
                          <td>{{workOrder.workOrder_Seq}}</td>
                          <td><span *ngIf="workOrder.workOrderType">{{workOrder.workOrderType.workOrderType_Desc}}</span></td>
                          <td>{{workOrder.workOrder_Start | date: 'MM/dd/yyyy h:mm a'}}</td>
                          <td>{{workOrder.workOrder_Stop | date: 'MM/dd/yyyy h:mm a'}}</td>
                          <td>
                            <button *ngIf="canEditWorkOrder && workOrder.workOrder_ID !== null " type="button" class="btn btn-bidit-edit" (click)="editWorkOrder(workOrder)"></button>
                          </td>
                        </tr>
                      </ng-template>
                    </ng-template>

                  </tbody>

                </table>
              </div>
            </div>
          </mat-tab>
          <mat-tab [label]="noteLabel">
            <app-project-notes [project]="job"
                               (updated)="jobNotesUpdated($event)"></app-project-notes>
          </mat-tab>
          <mat-tab [label]="documentLabel">
            <app-project-documents [project]="job"
                                   (updated)="jobNotesUpdated($event)"></app-project-documents>
          </mat-tab>
          <mat-tab *ngIf="!isFieldTech" label="Change Orders" i18n-label>
            <div *ngIf="!showChangeOrder; then showChangeOrders else showChangeOrderEdit" class="container-fluid"></div>
            <ng-template #showChangeOrders>
              <div class="container-fluid">
                <div class="form-inline">
                  <h5 class="mr-1" i18n>Pending Change Orders</h5>
                  <button *ngIf="canAddChangeOrder" type="button" class="btn btn-bidit-navigate" (click)="newChangeOrder()" i18n>New Change Order</button>
                </div>
                <table class="table table-bidit table-striped">
                  <thead>
                    <tr>
                      <th i18n>Name</th>
                      <th i18n>Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-changeOrder [ngForOf]="job.changeOrders">
                      <tr *ngIf="changeOrder.changeOrderStatusType_ID == 1">
                        <td>{{changeOrder.changeOrder_Name}}</td>
                        <td>
                          <span *ngIf="changeOrder.changeOrder_BidAmount">${{changeOrder.changeOrder_BidAmount | number: '1.0'}}</span>
                        </td>
                        <td>
                          <div *ngIf="!isRequesting">
                            <button type="button" class="btn btn-bidit-edit" (click)="editChangeOrder(changeOrder.changeOrder_ID)"></button>
                            <button *ngIf="allowPrint" type="button" class="btn btn-bidit-navigate ml-1" (click)="printChangeOrder(changeOrder)" i18n>Print</button>
                            <button *ngIf="canEditChangeOrder" type="button" class="btn btn-bidit-warn ml-1" (click)="deleteChangeOrder(changeOrder.changeOrder_ID)" i18n>Delete</button>
                          </div>
                          <app-spinner [isRunning]="isRequesting"></app-spinner>
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
                <h5 i18n>Approved Change Orders</h5>
                <table class="table table-bidit table-striped">
                  <thead>
                    <tr>
                      <th i18n>Revision</th>
                      <th i18n>Name</th>
                      <th i18n>Amount</th>
                      <th i18n>Approved Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td i18n>Original Quote</td>
                      <td>${{job.quote_BidAmount | number: '1.0'}}</td>
                      <td>{{job.quote_Converted | date: 'MM/dd/yyyy'}}</td>
                      <td>
                        <div *ngIf="!isRequesting">
                          <button *ngIf="canEditChangeOrder && allowPrint" type="button" class="btn btn-bidit-navigate" (click)="printQuote(null)" i18n>Print</button>
                          <button *ngIf="canEditChangeOrder && allowPrint" type="button" class="btn btn-bidit-navigate ml-1" (click)="printInvoice(null, false)" i18n>Invoice</button>
                          <button *ngIf="canEditChangeOrder && allowPrint" type="button" class="btn btn-bidit-navigate ml-1" (click)="printInvoice(null, true)" i18n>Invoice All</button>
                        </div>
                        <app-spinner [isRunning]="isRequesting"></app-spinner>
                      </td>
                    </tr>
                    <ng-template ngFor let-changeOrder [ngForOf]="job.changeOrders">
                      <tr *ngIf="changeOrder.changeOrderStatusType_ID == 2">
                        <td>{{changeOrder.revision_ID}}</td>
                        <td>{{changeOrder.changeOrder_Name}}</td>
                        <td>
                          <span *ngIf="changeOrder.changeOrder_BidAmount">${{changeOrder.changeOrder_BidAmount + (changeOrder.netTax_Total ?? 0) | number: '1.0'}}</span>
                        </td>
                        <td>{{changeOrder.changeOrder_Approved | date: 'MM/dd/yyyy'}}</td>
                        <td>
                          <div *ngIf="!isRequesting">
                            <button *ngIf="canEditChangeOrder && allowPrint" type="button" class="btn btn-bidit-navigate" (click)="printChangeOrder(changeOrder)" i18n>Print</button>
                            <button *ngIf="canEditChangeOrder && allowPrint"type="button" class="btn btn-bidit-navigate ml-1" (click)="printInvoice(changeOrder.changeOrder_ID, false)" i18n>Invoice</button>
                          </div>
                          <app-spinner [isRunning]="isRequesting"></app-spinner>
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </ng-template>
            <ng-template #showChangeOrderEdit>
              <app-change-order-desktop [value]="changeOrderId" (toggleChangeOrderDisplay)="toggleChangeOrderDisplay($event)" (updated)="changeOrderUpdated($event)"></app-change-order-desktop>
            </ng-template>
          </mat-tab>
          <mat-tab label="Job Costing" i18n-label>
            <span i18n>Please provide actual numbers and click Submit</span>
            <table class="table table-bidit table-striped">
              <thead>
                <tr>
                  <th i18n>Area</th>
                  <th i18n>Item</th>
                  <th i18n>Qty Bid</th>
                  <th i18n>Qty Used</th>
                  <th i18n>SqrFtg Bid</th>
                  <th i18n>Actual Sqr Ftg</th>
                </tr>
              </thead>

              <tbody>
                <ng-template ngFor let-area [ngForOf]="areaSummaries">
                  <tr>
                    <td colspan="2">
                      <b>{{area.area_Name}}</b>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                    </td>
                  </tr>
                  <ng-template ngFor let-quoteArea [ngForOf]="area.quoteAreas">
                    <tr>
                      <td>
                        <b>
                          <span *ngIf="quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.area_Name}}</span>
                          <span *ngIf="!quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.subArea.subArea_Name}}</span>
                        </b>
                      </td>
                      <td>
                        <span *ngIf="quoteArea.acceptedItem.item">
                          {{quoteArea.acceptedItem.item.item_Name}}
                        </span>
                      </td>
                      <td>
                        {{quoteArea.acceptedItem.area_BidItemUsage}}
                      </td>
                      <td>
                        <input type="number" name="actualUsed" class="form-control"
                               [(ngModel)]="quoteArea.acceptedItem.area_ActualItemUsage" #actualUsed="ngModel" />
                      </td>
                      <td>
                        {{quoteArea.acceptedItem.area_SqrFtg}}
                      </td>
                      <td>
                        <input type="number" name="actualSqrFtg" class="form-control"
                               [(ngModel)]="quoteArea.acceptedItem.area_ActualSqrFtg" #actualSqrFtg="ngModel" />
                      </td>
                    </tr>
                    <tr *ngFor="let accessory of quoteArea.acceptedItem.accessories">
                      <td>
                        <b i18n>Accessory</b>
                      </td>
                      <td>
                        <span *ngIf="accessory.item">{{accessory.item.item_Name}}</span>
                        <span *ngIf="!accessory.item">{{accessory.accessory_CustomName}}</span>
                      </td>
                      <td>
                        {{accessory.accessory_Quantity}}
                      </td>
                      <td>
                        <input type="number" name="accessoryUsed" class="form-control"
                               [(ngModel)]="accessory.accessory_ActualUsage" #accessoryUsed="ngModel" />
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                    </tr>
                  </ng-template>
                </ng-template>
                <tr>
                  <td colspan="2">
                    <b i18n>Job Additional Items</b>
                    <button *ngIf="canEdit" type="button" class="btn btn-bidit-navigate float-right" (click)="customItem()" i18n>Add Additional Item</button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                  </td>
                </tr>
                <tr *ngFor="let jobAdditionalItem of job.jobAdditionalItems">
                  <td>
                    {{jobAdditionalItem.item.itemType.itemType_Desc}}
                  </td>
                  <td>
                    {{jobAdditionalItem.item.item_Name}}
                    <button type="button" *ngIf="canEdit" class="ml-2 btn btn-bidit-delete"
                            title="Remove custom item" i18n-title (click)="removeCustomItem(jobAdditionalItem)"></button>
                  </td>
                  <td>
                  </td>
                  <td>
                    <input type="number" name="accessoryUsed" class="form-control"
                           [(ngModel)]="jobAdditionalItem.jobAdditionalItem_ActualUsage" #accessoryUsed="ngModel" />
                  </td>
                  <td>
                  </td>
                  <td>
                    <input *ngIf="jobAdditionalItem.item.itemType.itemType_IsAccessory == false"
                           type="number" name="accessoryUsed" class="form-control"
                           [(ngModel)]="jobAdditionalItem.jobAdditionalItem_ActualSqrFtg" #accessoryUsed="ngModel" />
                  </td>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th i18n>Area</th>
                  <th i18n>Item</th>
                  <th i18n>Unit Cost $</th>
                  <th i18n>Qty Used</th>
                  <th i18n>SqrFtg Bid</th>
                  <th i18n>Actual Sqr Ftg</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2">
                    <b i18n>Custom Areas</b>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                  </td>
                </tr>
                <tr *ngFor="let customItem of job.jobCustomItems">
                  <td>
                    {{customItem.customItemDescription}}
                  </td>
                  <td>
                    {{customItem.customItemProduct}}
                  </td>
                  <td>
                    <input type="number" step=".01" name="itemCost" class="form-control"
                           [(ngModel)]="customItem.jobCustomItem_ItemCost" actualUsage="ngModel" />
                  </td>
                  <td>
                    <input type="number" name="actualUsage" class="form-control"
                           [(ngModel)]="customItem.jobCustomItem_ActualUsage" actualUsage="ngModel" />
                  </td>
                  <td>
                  </td>
                  <td>
                    <input type="number" name="actualSqrFtg" class="form-control"
                           [(ngModel)]="customItem.jobCustomItem_ActualSqrFtg" actualSqrFtg="ngModel" />
                  </td>
                </tr>
              </tbody>
            </table>

            <button type="button" (click)="updateJobCosting()" onclick="this.blur();" class="mb-1 ml-1 btn btn-bidit-action" i18n>Submit</button>
          </mat-tab>
          <mat-tab *ngIf="job.quoteAcknowledgements" [label]="acknowledgementLabel">
            <div class="pt-3">
              <app-acknowledgement-list [project]="job"></app-acknowledgement-list>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

    </div>
  </div>
</div>
